module.exports = __webpack_public_path__ + "img/bar5.082b39d8.png";